import Vue from "vue";

export default {
    login (state, user) {
        if (typeof user === 'string') {
            user = JSON.parse(user);
        }

        localStorage.setItem('user', JSON.stringify(user));

        if (state.user === null) {
            Vue.set(state, 'user', user);
        }

        window.axios.defaults.params['api_token'] = user.api_token;
        if (user.real_api_token !== undefined && user.real_api_token) {
            window.axios.defaults.params['real_api_token'] = user.real_api_token;
            state.user.real_api_token = user.real_api_token;
        }

        let appVersion = document.head.querySelector('meta[name="app-version"]').content;
        let newVersion = localStorage.getItem('app-version') !== appVersion;

        if (state.user !== null || newVersion) {
            this.dispatch('loadAll', newVersion);
        }

        if (newVersion) {
            localStorage.setItem('app-version', appVersion);
        }
    },
    logout (state) {
        delete axios.defaults.params['api_token'];
        delete axios.defaults.params['real_api_token'];

        localStorage.removeItem('user');

        Vue.set(state, 'user', null);

        let keys = [
            'dancers', 'starterTemplates', 'starterTypes',
            'starterStyles', 'events', 'registrations',
            'users', 'eventTypes'
        ];

        _.each(keys, key => {
            state[key] = {
                loaded: false,
                items: []
            };
        })
    },
    updateUser(state, user) {
        let currentUser = localStorage.getItem('user');
        if (!currentUser) {
            return;
        }
        currentUser = JSON.parse(currentUser);

        if (currentUser.id !== user.id) {
            return;
        }

        _.each(user, (value, key) => {
            if (Array.isArray(value)) {
                return;
            }

            Vue.set(currentUser, key, value);
            Vue.set(state.user, key, value);
        });

        localStorage.setItem('user', JSON.stringify(currentUser));
    },
    loadDancers (state, response) {
        this.commit('loadItems', {
            itemsKey: 'dancers',
            response: response
        });
    },
    addDancer(state, dancer) {
        state.dancers.items.push(dancer);
    },
    updateDancer(state, dancer) {
        this.commit('updateItem', {
            itemsKey: 'dancers',
            item: dancer
        });
    },
    removeDancer(state, id) {
        this.commit('removeItem', {
            itemsKey: 'dancers',
            id: id
        });
    },
    loadStarterTypes(state, response) {
        this.commit('loadItems', {
            itemsKey: 'starterTypes',
            response: response
        });
    },
    loadAgeGroups (state, response) {
        this.commit('loadItems', {
            itemsKey: 'ageGroups',
            response: response
        });
    },
    loadEventTypes(state, response) {
        this.commit('loadItems', {
            itemsKey: 'eventTypes',
            response: response
        });
    },
    loadStarterStyles(state, response) {
        Vue.set(state.starterStyles, 'items', response.data.data);
        state.starterStyles.loaded = true;
    },
    loadStarterTemplates (state, response) {
        Vue.set(state.starterTemplates, 'items', response.data.data);
        state.starterTemplates.loaded = true;
    },
    addStarterTemplate(state, starterTemplate) {
        state.starterTemplates.items.push(starterTemplate);
    },
    updateStarterTemplate(state, starterTemplate) {
        this.commit('updateItem', {
            itemsKey: 'starterTemplates',
            item: starterTemplate
        });
    },
    removeStarterTemplate(state, id) {
        this.commit('removeItem', {
            itemsKey: 'starterTemplates',
            id: id
        });
    },
    loadEvents (state, response) {
        this.commit('loadItems', {
            itemsKey: 'events',
            response: response
        });
    },
    addEvent(state, event) {
        state.events.items.push(event);
    },
    updateEvent(state, event) {
        this.commit('updateItem', {
            itemsKey: 'events',
            item: event
        });
    },
    removeEvent(state, id) {
        this.commit('removeItem', {
            itemsKey: 'events',
            id: id
        });
    },
    loadRegistrations(state, response) {
        this.commit('loadItems', {
            itemsKey: 'registrations',
            response: response
        });
    },
    addRegistration(state, registration) {
        state.registrations.items.push(registration);
    },
    updateRegistration(state, registration) {
        state.registrations.items.forEach(item => {
            if (item.id === registration.id) {
                item.has_music = registration.has_music;

                return false;
            }
        });
    },
    removeRegistration(state, id) {
        this.commit('removeItem', {
            itemsKey: 'registrations',
            id: id
        });
    },
    loadStarters(state, response) {
        this.commit('loadItems', {
            itemsKey: 'starters',
            response: response
        });
    },
    loadItems(state, params){
        Vue.set(state[params.itemsKey], 'items', params.response.data.data);
        state[params.itemsKey].loaded = true;
    },
    removeItem(state, params){
        let index = -1;
        state[params.itemsKey].items.forEach((item, _id) => {
            if (params.id === item.id) {
                index = _id;
                return false;
            }
        });

        if (index > -1) {
            state[params.itemsKey].items.splice(index, 1);
        }
    },
    updateItem(state, params) {
        let index = -1;
        state[params.itemsKey].items.forEach((item, _id) => {
            if (params.item.id === item.id) {
                index = _id;
                return false;
            }
        });

        if (index === -1) {
            return;
        }

        _.each(state[params.itemsKey].items, item => {
            if (item.id === params.item.id) {
                _.each(item, (value, key) => {
                    if (!item.hasOwnProperty(key) || !params.item.hasOwnProperty(key)) {
                        return;
                    }
                    if (value !== params.item[key] || value instanceof Object) {
                        Vue.set(item, key, params.item[key]);
                    }
                });

                return false;
            }
        });
    },
    loadUser (state, response) {
        state.user.balance = response.data.data.balance
    },
    loadUsers (state, response) {
        Vue.set(state.users, 'items', response.data.data);
        state.users.items.forEach(user => {
            user.selectText = `${user.first_name} ${user.last_name}` + ' (' + (user.company ? `${user.company}; ` : '') + `${user.email})`;
        });
        state.users.loaded = true;
    },
    setUserData(state, from) {
        _.each(from, (value, key) => {
            if (state.user.hasOwnProperty(key) && from.hasOwnProperty(key)) {
                state.user[key] = value;
            }
        });
    },
    switchUser(state, user) {
        this.commit('resetUser', false);

        let currentUser = JSON.parse(localStorage.getItem('user'));

        currentUser.real_api_token = currentUser.api_token;
        state.user.real_api_token = currentUser.api_token;

        currentUser.api_token = user.api_token;
        state.user.api_token = user.api_token;

        localStorage.setItem('user', JSON.stringify(currentUser));

        //state.user.rules = user.rules;

        axios.defaults.params['real_api_token'] = state.user.real_api_token;
        axios.defaults.params['api_token'] = state.user.api_token;

        this.commit('setUserData', user);
        this.dispatch('loadDancers');
        this.dispatch('loadStarterTemplates');
        this.dispatch('loadRegistrations');
        this.dispatch('loadStarters');
        this.dispatch('loadEvents');
    },
    resetUser(state, reload = true) {
        let currentUser = JSON.parse(localStorage.getItem('user'));

        if (currentUser.real_api_token === undefined) {
            return;
        }

        currentUser.api_token = currentUser.real_api_token;
        delete currentUser.real_api_token;
        Vue.delete(state.user, 'real_api_token');

        state.user.api_token = currentUser.api_token;

        localStorage.setItem('user', JSON.stringify(currentUser));

        //state.user.rules = user.rules;

        delete axios.defaults.params['real_api_token'];
        axios.defaults.params['api_token'] = state.user.api_token;

        this.commit('setUserData', currentUser);

        state.dancers.loaded = false;
        state.starterTemplates.loaded = false;

        Vue.set(state.dancers, 'items', []);
        Vue.set(state.starterTemplates, 'items', []);

        if (reload) {
            this.dispatch('loadDancers');
            this.dispatch('loadStarterTemplates');
            this.dispatch('loadRegistrations');
            this.dispatch('loadStarters');
            this.dispatch('loadEvents');
        }
    },
    confirm(state, config) {
        state.dialogs.confirm.headline = config.headline;
        state.dialogs.confirm.text = config.text;
        state.dialogs.confirm.confirmCallback = config.callback;
        state.dialogs.confirm.cancelCallback = config.hasOwnProperty('cancel') ? config.cancel : null;
        state.dialogs.confirm.active = true;
    },
    info(state, config) {
        state.dialogs.info.headline = config.headline;
        state.dialogs.info.text = config.text;
        state.dialogs.info.copyTitle = config.copyTitle !== undefined ? config.copyTitle : '';
        state.dialogs.info.copyText = config.copyText !== undefined ? config.copyText : '';
        state.dialogs.info.active = true;
        state.dialogs.info.actions = config.actions !== undefined ? config.actions : [];
    },
    snackBar(state, config) {
        state.snackBar.active = true;
        state.snackBar.text = config.text;
        state.snackBar.color = config.color;

        if (config.timeout !== undefined) {
            state.snackBar.timeout = config.timeout;
        }
    }
}
